import {LegendProps} from "recharts";
import {Grid, Stack, Typography} from "@mui/material";
import SquareRoundedIcon from "@mui/icons-material/SquareRounded";

interface ItemPayload {
    fill: string;
    stroke: string;
    strokeDasharray: string;
}

export const BaseChartLegend: React.FC<LegendProps> = ({payload}) => {
    if (payload) {
        return (
            <Grid container spacing="1.5rem" direction="row-reverse" rowSpacing="0.5rem">
                {payload
                    .slice()
                    .reverse()
                    .filter((item) => item.type !== "none")
                    .map((entry, index) => (
                        <Grid item key={`item-${index}`}>
                            <Stack direction="row" gap="0.4rem">
                                <SquareRoundedIcon
                                    sx={{
                                        fill: (entry.payload as unknown as ItemPayload).fill,
                                        stroke: (entry.payload as unknown as ItemPayload).stroke,
                                        strokeWidth: 2,
                                        width: 18,
                                        height: 18,
                                        strokeDasharray: (entry.payload as unknown as ItemPayload).strokeDasharray,
                                    }}
                                />
                                <Typography fontSize={14} textTransform="uppercase">
                                    {entry.value}
                                </Typography>
                            </Stack>
                        </Grid>
                    ))}
            </Grid>
        );
    } else {
        return null;
    }
};
